// PYQ (Previous Year Questions) Domain Types
// Based on OpenAPI specs: questions-query-api.yaml & syllabus-query-api.yaml

export type DifficultyLevel = 'EASY' | 'MEDIUM' | 'HARD'
export type QuestionType = 'NUMERICAL' | 'CONCEPTUAL' | 'THEORETICAL' | 'ANALYTICAL'
export type IntellectualComplexity = 'KNOWLEDGE' | 'COMPREHENSION' | 'APPLICATION' | 'ANALYSIS' | 'EVALUATION' | 'SYNTHESIS'
export type Subject = 'Physics' | 'Chemistry' | 'Biology'

// NEET Question Data structure
export interface NeetQuestionData {
  examType: 'NEET'
  text: string
  options: string[]
  images?: string[]
}

// NEET Solution Data structure
export interface NeetSolutionData {
  examType: 'NEET'
  answer: string
  explanation?: string
  steps?: string[]
  images?: string[]
  videoUrl?: string
  hints?: string[]
  keyConcepts?: string[]
}

// Full Question Response (from /questions/{id})
export interface QuestionResponse {
  questionId: string
  difficultyLevel: DifficultyLevel
  questionType: QuestionType
  intellectualComplexity: IntellectualComplexity
  questionData: NeetQuestionData
  solutionData?: NeetSolutionData
  tags?: string[]
  testCode?: string
  createdAt: string
  updatedAt: string
}

// Question Summary (from /questions/batch)
export interface QuestionSummary {
  questionId: string
  questionText: string
  difficultyLevel: DifficultyLevel
  questionType: QuestionType
  subjectName?: string
  topicName?: string
}

// Batch Question Summary Response
export interface BatchQuestionSummaryResponse {
  questions: QuestionSummary[]
}

// Question-Topic Mapping Response (from syllabus API)
export interface QuestionMappingResponse {
  id: string
  nodeId: string
  nodeCode: string
  nodeName: string
  questionId: string
  isPrimaryTopic: boolean
  weightage: number
  createdAt: string
  updatedAt: string
}

// Question Mappings Response wrapper
export interface QuestionMappingsResponse {
  mappings: QuestionMappingResponse[]
}

// API Response wrapper
export interface ApiResponse<T> {
  success: boolean
  message: string
  data: T
  timestamp: string
}

// Pagination info from search API
export interface PageInfo {
  number: number
  size: number
  totalElements: number
  totalPages: number
  first: boolean
  last: boolean
  hasNext: boolean
  hasPrevious: boolean
}

// PYQ Filter Form State
export interface PYQFilterState {
  yearStart: number
  yearEnd: number
  subject: Subject | ''
  unitCode: string
}

// Unit option for dropdown
export interface UnitOption {
  nodeCode: string
  nodeName: string
}

// Subject options with node codes
export const SUBJECT_CODES: Record<Subject, string> = {
  'Physics': 'PHY',
  'Chemistry': 'CHEM',
  'Biology': 'BIO'
}

// Generate year options (past 10 years)
export const YEAR_OPTIONS = Array.from({ length: 10 }, (_, i) => {
  const year = new Date().getFullYear() - i
  return year
})

// Syllabus code constant
export const SYLLABUS_CODE = 'NEET_UG'

// PYQ exams list (GET /questions/pyq/exams)
export interface PyqExam {
  testCode: string
  /** Full display name, e.g. "NEET 2026 Re-Exam" */
  label: string
}

export interface PyqYear {
  year: number
  exams: PyqExam[]
}

export interface PyqExamsResponse {
  /** Sorted newest first */
  years: PyqYear[]
}
